import { render } from "./invoices_index.vue?vue&type=template&id=674cf562&scoped=true"
import script from "./invoices_index.vue?vue&type=script&lang=js"
export * from "./invoices_index.vue?vue&type=script&lang=js"

import "./invoices_index.vue?vue&type=style&index=0&id=674cf562&scoped=true&lang=css"

import exportComponent from "/home/denoh/aiwork/second/in_client/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-674cf562"]])

export default __exports__